<template>
  <div id="preloader"
    style="
      position: fixed;
      width: 100%;
      height: 100%;
      z-index: 50;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #fff;
    "
  >
    <div
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
      "
    >
      <figure class="arrow-anim"
        style="max-width: 7rem"
      >
        <img src="/images/preload.webp" fetchpriority="high" alt="" srcset="/images/preload.webp 191w">
      </figure>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  isLoading: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['ready']);
const handleLoaded = () => {
  emit('ready');
};

const { $anime } = useNuxtApp();

const animateArrow = () => {
  $anime({
    targets: '.arrow-anim',
    opacity: 1,
    // translateY: [-500, 0],
    duration: 500,
    easing: 'easeOutElastic(1, 1)',
  });
};

onMounted(() => {
  nextTick(() => {
    animateArrow();
  });
});

watch(() => props.isLoading,
  val => {
    if (!val) {
      const to = setTimeout(() => {
        $anime({
          targets: '.arrow-anim',
          rotate: 359,
          scale: 1.1,
          duration: 2000,
          easing: 'easeOutElastic(1, 1.3)',
          complete: function (anim) {
            clearTimeout(to);
            handleLoaded();
          },
        });
      }, 800);
    }
  },
);
</script>

<style lang="scss">
</style>
